import localRobot from '@/common/localRobot.js';
import modelChoiceStore from '@/components/model-choice/store';
import global from '@/store/global';
import navbarStore from '@/store/navbar';
import { request } from '@src/common';
import { HelperCore } from '@src/common/helper';
import Loader from '@src/common/helper/loader';
import { makeAutoObservable, runInAction } from 'mobx';

class Store {
  customAIbots = []; // 自定义模型
  officialAIbots = []; // 官方ai助手
  apiAIbots = []; // 三方API模型
  privateAIbots = []; // 私有API模型
  allInOneAIbots = []; // 一体机
  recommendAIbots = []; // 推荐ai助手
  bigModelAIbots = []; // 大模型
  curAIbotInfo = {};
  curSugInfo = {};
  total = 0;
  isModelListDirty = false;

  get tabList(){
     let list = global.cloudConfig.assistantAbilityTabMap?.category || '{}'
     try {
      list = JSON.parse(list)
      list = Object.keys(list).map(x=>{
        let item = list[x]
        item.category = x
        return item
      })
     } catch (error) {
      console.log(error);
      return []
     }
     return list
  }

  get sugList(){
    let list = global.cloudConfig.assistantAbilityTabList || []
    let obj = {}
    try {
     list.forEach(x=>{
      if(obj[x.category]) {
        obj[x.category].push(x)
      }else {
        obj[x.category] = [x]
        // obj[x.category] = this.tabList.filter(item => item.category == x.category)
      }
     })
    } catch (error) {
     console.log(error);
     return {}
    }
    return obj
 }

  constructor() {
    makeAutoObservable(this);

    if (!HelperCore.IS_ONLINE) {
      window._homeStore = this;
    }
  }

  setData (key, value) {
    this[key] = value;
  }

  setDirty(bool = true) {
    this.isModelListDirty = bool;
    this.isModelListDirty = bool;
  }

  updateModelList = (shouldCheckDirty) => {

    if (shouldCheckDirty && !this.isModelListDirty) {
      return
    }

    this.isModelListDirty = false
    return this.getOfficialAIbot()
  }

  improveDSPriority = (list) => {
    return list
  }
  /**
   * 首页模型列表
   * @param {(10 | 100)} modelType 10 - 广场模型列表， 100 - 自定义模型列表
   */
  getOfficialAIbot = () => {
    const { pushFrontId, switchCurId, curId } = modelChoiceStore;

    return request
      .get('/robot/platform', {
        params: {chat_type: 10,} // ai_agent设置为1时，返回AI智能体
      })
      .then(res => {
        const list = (res.data?.list || []).concat(localRobot.localModels);
        navbarStore.setChatModels(list);
        this.total = res.data?.total || res.data?.list.length || 0;
        runInAction(() => {
          this.customAIbots = list.filter(item => item.chat_type === 100);
          // this.officialAIbots = list.filter(item => item.chat_type === 10 || item.state === 1);
          this.officialAIbots = list.filter(item => item.model_type === 0);
          this.apiAIbots = list.filter(item => item.model_type === 2 && item.model_tab === '2');
          this.privateAIbots = list.filter(item => item.model_type === 3);
          this.allInOneAIbots = list.filter(item => item.model_type === 4);
          this.bigModelAIbots = list.filter(item => item.model_type === 2 && item.model_tab === '1');

          if (!list.find(model => model.id === curId)) {
            // 如果旧的不在了 则切换到第一个
            const index = this.officialAIbots.findIndex((item) => item.title && /deepseek.*满血/i.test(item.title));
            if (index !== -1) {
              pushFrontId(this.officialAIbots[index].id)
              switchCurId(this.officialAIbots[index].id);
            } else {
              pushFrontId(this.officialAIbots[0].id)
              switchCurId(this.officialAIbots[0].id)
            }
          }

          if (!this.customAIbots.length) {
            modelChoiceStore.switchTab(10)
          }
        });
      })
      .catch(Loader.error)
      .finally(() => {
        runInAction(() => {
        });
      });
  }


  /**
   * 推荐助手
   */
  getRecommendAIbot = () => {
    request
      .get('/robot/index', {})
      .then(res => {
        const list = res.data?.list || [];
        navbarStore.setChatModels(list);
        runInAction(() => {
          this.recommendAIbots = list;
        });
      })
      .catch(Loader.error)
      .finally(() => {
        runInAction(() => {
        });
      });
  };

  /**
   * 分割助手数据
   * @param {*} array
   * @param {*} chunkSize  每个子数组的大小（首页是8）
   * @returns
   */
  splitArray = (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }

    return result;
  }

  /**
   * 查询助手信息
   */
  findAIbotById = (list, id) => {
    const item = list.find(item => item.id === id);
    if (item) {
      return this.curAIbotInfo = {
        title: item.title,
        icon: item.icon
      };
    }
    return null;
  };

}

const homeStore = new Store();
export default homeStore;
